import type { MarkerProps } from '@react-google-maps/api';
import { GoogleMap, Marker } from '@react-google-maps/api';
import * as React from 'react';
import { Row, Col } from 'react-bootstrap';

import styles from './styles.module.scss';
import GoogleScriptLoader from '../Shared/Loader';

export type OnMapClickFunction = (location: google.maps.MapMouseEvent) => void;

interface OwnProps {
	onMapClick: OnMapClickFunction;
	marker: Nullable<MarkerProps>;
	center: google.maps.LatLng | google.maps.LatLngLiteral;
	zoom: number;
}

type Props = OwnProps;

const MapRow: React.FC<Props> = (props) => {
	const { onMapClick, marker, center, zoom } = props;

	return (
		<Row>
			<Col className={styles['address__address-column--no-padding']} sm={24}>
				<GoogleScriptLoader>
					<GoogleMap
						center={center}
						mapContainerStyle={{ height: '400px', width: '100%' }}
						onClick={onMapClick}
						zoom={zoom}
					>
						{!!marker
							? <Marker {...marker} />
							: <></>
						}
					</GoogleMap>
				</GoogleScriptLoader>
			</Col>
		</Row>
	);
};

export default React.memo(MapRow);
